const OngoingOrderSkeleton = () => <div className="border-supportiveDarkGray animate-pulse border-b pb-4" data-sentry-component="OngoingOrderSkeleton" data-sentry-source-file="OngoingOrderSkeleton.jsx">
    {/* Section title */}
    <div className="pb-3">
      <div className="mb-2 h-5 w-40 rounded bg-gray-300" />
    </div>

    {/* Simulated OrdersCard */}
    <div className="border-supportiveThinGray mb-4 space-y-3 rounded-lg border py-4">
      <div className="h-4 w-32 rounded bg-gray-300" />
      <div className="h-4 w-3/4 rounded bg-gray-300" />
      <div className="flex space-x-2">
        <div className="h-4 w-1/4 rounded bg-gray-300" />
        <div className="h-4 w-1/4 rounded bg-gray-300" />
        <div className="h-4 w-1/4 rounded bg-gray-300" />
      </div>
    </div>

    {/* Button skeleton */}
    <div className="h-10 w-full rounded bg-gray-300" />
  </div>;
export default OngoingOrderSkeleton;